<div class="logo-wrapper" [appContentPosition]="logoPosition">
    <a href="https://www.globus-baumarkt.de/"><img alt="Globus Baumarkt Logo" src="/sso/assets/img/acid/logo.svg" class="logo" /></a>
    <!--    <img *ngIf="logoURL && logoURL !== ''" src="{{logoURL}}" class="logo" />-->
</div>
